import { render, staticRenderFns } from "./VerifyPage.vue?vue&type=template&id=6a2906de&scoped=true&"
import script from "./VerifyPage.vue?vue&type=script&lang=js&"
export * from "./VerifyPage.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPage.vue?vue&type=style&index=0&id=6a2906de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2906de",
  null
  
)

export default component.exports